import script from "./digitalTwin.vue?vue&type=script&setup=true&lang=js"
export * from "./digitalTwin.vue?vue&type=script&setup=true&lang=js"

import "./digitalTwin.vue?vue&type=style&index=0&id=398677a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398677a9"]])

export default __exports__